var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('forget-password',{attrs:{"forgotPasswrodRequestIsDone":_vm.forgotPasswrodRequestIsDone},on:{"forgotPassword":_vm.forgotPassword,"resetPassword":_vm.resetPassword,"resendAuthCode":_vm.resendAuthCode,"goLogin":_vm.goLogin}})}
var staticRenderFns = []

export { render, staticRenderFns }